import { apolloClient } from 'App';

import { GetSubcategoriesOfCategoryQuery, SubcategoryFragment } from 'data/__generated__';
import { GET_SUBCATEGORIES_OF_CATEGORY_QUERY } from 'data/queries/subcategory';

export const subcategoryAddedHandler = ({
    categoryId,
    addedSubcategory,
}: {
    categoryId: string;
    addedSubcategory: SubcategoryFragment;
}) => {
    const result = apolloClient.readQuery<GetSubcategoriesOfCategoryQuery>({
        query: GET_SUBCATEGORIES_OF_CATEGORY_QUERY,
        variables: { categoryId },
    });

    if (!result) {
        return;
    }

    const { subcategoriesOfCategory } = result;

    const data = {
        subcategoriesOfCategory: [...subcategoriesOfCategory, addedSubcategory],
    };

    apolloClient.writeQuery({
        query: GET_SUBCATEGORIES_OF_CATEGORY_QUERY,
        variables: { categoryId },
        data,
    });
};
